export default {
  CREATE_REQUEST: (state) => {
    state.newItem.isLoading = true;
    state.newItem.data = null;
    state.newItem.error = null;
  },
  CREATE_SUCCESS: (state, newItem) => {
    state.newItem.isLoading = false;
    state.newItem.data = newItem;
  },
  CREATE_ERROR: (state, error) => {
    state.newItem.isLoading = false;
    state.newItem.error = error;
  },

  UPDATE_REQUEST: (state) => {
    state.updateItem.isLoading = true;
    state.updateItem.data = null;
    state.updateItem.error = null;
  },
  UPDATE_SUCCESS: (state, updateItem) => {
    state.updateItem.isLoading = false;
    state.updateItem.data = updateItem;
  },
  UPDATE_ERROR: (state, error) => {
    state.updateItem.isLoading = false;
    state.updateItem.error = error;
  },

  DELETE_REQUEST: (state) => {
    state.deleteItem.isLoading = true;
    state.deleteItem.data = null;
    state.deleteItem.error = null;
  },
  DELETE_SUCCESS: (state, id) => {
    state.deleteItem.isLoading = false;
    state.deleteItem.data = id;
  },
  DELETE_ERROR: (state, error) => {
    state.deleteItem.isLoading = false;
    state.deleteItem.error = error;
  },
};
